import Cookies from 'js-cookie'
import {fetchDataDictList} from "../../api/data-dict";
import { fetchListLess } from "../../api/student";
import { fetchClassesList } from "../../api/classes";

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    dict: [],
    studentLess: [],
    classes: [],
    school:[],
    classRoom:[]
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    DATA_DICT: (state, dict) => {
      state.dict = dict
    },
    STUDENTS_LESS: (state, students) => {
      state.studentLess = students
    },
    CLASSES: (state, classes) => {
      state.classes = classes
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    DataDict({ commit }) {
      fetchDataDictList({
        page: 1,
        limit: 9999
      }).then(res => {
        commit('DATA_DICT', res.data)
      })

    },
    StudentLess({ commit }) {
      fetchListLess().then(res => {
        commit('STUDENTS_LESS', res.data)
      })
    },
    Classes({commit }) {
      fetchClassesList({page: 1,
        limit: 100,
        fatherId: 0,}).then(res => {
          commit('CLASSES', res.data)
      })
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js